import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function SocialSecurityIcon({ className }: IconProps) {
  return (
    <svg
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_1011)">
        <path
          d="M63.9563 62.1351H3.04297C3.04297 60.1062 4.67993 58.4692 6.70883 58.4692H60.3134C62.3424 58.4692 63.9793 60.1062 63.9793 62.1351"
          fill="#00C4B3"
        />
        <path
          d="M3.04297 23.7476H63.9563C63.9563 25.7765 62.3193 27.4134 60.2904 27.4134H6.70883C4.67993 27.4134 3.04297 25.7765 3.04297 23.7476Z"
          fill="#00C4B3"
        />
        <path
          d="M37.765 27.4131H29.2344V58.4692H37.765V27.4131Z"
          fill="#EAEDF8"
        />
        <path
          d="M17.3607 27.4131H8.83008V58.4692H17.3607V27.4131Z"
          fill="#EAEDF8"
        />
        <path
          d="M58.1693 27.4131H49.6387V58.4692H58.1693V27.4131Z"
          fill="#EAEDF8"
        />
        <path
          d="M37.7652 58.4691H29.2346C28.4046 58.4691 27.7129 57.7775 27.7129 56.9475C27.7129 56.1175 28.4046 55.4258 29.2346 55.4258H37.7652C38.6183 55.4258 39.2869 56.1175 39.2869 56.9475C39.2869 57.7775 38.6183 58.4691 37.7652 58.4691Z"
          fill="#EAEDF8"
        />
        <path
          d="M37.7652 30.4564H29.2346C28.4046 30.4564 27.7129 29.7648 27.7129 28.9348C27.7129 28.1048 28.4046 27.4131 29.2346 27.4131H37.7652C38.6183 27.4131 39.2869 28.1048 39.2869 28.9348C39.2869 29.7648 38.6183 30.4564 37.7652 30.4564Z"
          fill="#EAEDF8"
        />
        <path
          d="M17.3609 58.4691H8.83027C8.00027 58.4691 7.30859 57.7775 7.30859 56.9475C7.30859 56.1175 8.00027 55.4258 8.83027 55.4258H17.3609C18.214 55.4258 18.8826 56.1175 18.8826 56.9475C18.8826 57.7775 18.214 58.4691 17.3609 58.4691Z"
          fill="#EAEDF8"
        />
        <path
          d="M17.3609 30.4564H8.83027C8.00027 30.4564 7.30859 29.7648 7.30859 28.9348C7.30859 28.1048 8.00027 27.4131 8.83027 27.4131H17.3609C18.214 27.4131 18.8826 28.1048 18.8826 28.9348C18.8826 29.7648 18.214 30.4564 17.3609 30.4564Z"
          fill="#EAEDF8"
        />
        <path
          d="M58.1695 58.4691H49.6389C48.8089 58.4691 48.1172 57.7775 48.1172 56.9475C48.1172 56.1175 48.8089 55.4258 49.6389 55.4258H58.1695C59.0226 55.4258 59.6912 56.1175 59.6912 56.9475C59.6912 57.7775 59.0226 58.4691 58.1695 58.4691Z"
          fill="#EAEDF8"
        />
        <path
          d="M58.1695 30.4564H49.6389C48.8089 30.4564 48.1172 29.7648 48.1172 28.9348C48.1172 28.1048 48.8089 27.4131 49.6389 27.4131H58.1695C59.0226 27.4131 59.6912 28.1048 59.6912 28.9348C59.6912 29.7648 59.0226 30.4564 58.1695 30.4564Z"
          fill="#EAEDF8"
        />
        <path
          d="M64.5791 67.0001H2.44391C1.10668 67.0001 0 65.9165 0 64.5562C0 63.1959 1.08362 62.1123 2.44391 62.1123H64.5791C65.9164 62.1123 67.0231 63.1959 67.0231 64.5562C67.0231 65.9165 65.9394 67.0001 64.5791 67.0001Z"
          fill="#00416B"
        />
        <path
          d="M35.4827 0.599354C34.2838 -0.207597 32.6929 -0.207597 31.494 0.599354L0.553218 21.5109C-0.484291 22.1795 0.0229357 23.7473 1.26795 23.7473H65.7318C66.9768 23.7473 67.484 22.1795 66.4465 21.5109L35.4827 0.599354Z"
          fill="#00416B"
        />
        <path
          d="M39.2869 13.3954C39.2869 16.6001 36.7046 19.1824 33.4999 19.1824C30.2951 19.1824 27.7129 16.6001 27.7129 13.3954C27.7129 10.1906 30.2951 7.6084 33.4999 7.6084C36.7046 7.6084 39.2869 10.1906 39.2869 13.3954Z"
          fill="white"
        />
        <path
          d="M37.1657 13.3954C37.1657 15.4243 35.5288 17.0612 33.4998 17.0612C31.4709 17.0612 29.834 15.4243 29.834 13.3954C29.834 11.3665 31.4709 9.72949 33.4998 9.72949C35.5288 9.72949 37.1657 11.3665 37.1657 13.3954Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_1011">
          <rect width="67" height="67" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
